import request from '../utils/http'
// 异常原因列表
export function index (query) {
  return request({
    url: '/reason/index',
    method: 'GET',
    params: query
  })
}
// 新增
export function save (query) {
  return request({
    url: '/reason/save',
    method: 'POST',
    data: query
  })
}
// 编辑
export function edit (query) {
  return request({
    url: '/reason/edit',
    method: 'POST',
    data: query
  })
}
// 更新
export function update (query) {
  return request({
    url: '/reason/update',
    method: 'POST',
    data: query
  })
}
// 用户开关
export function show (query) {
  return request({
    url: '/reason/show',
    method: 'POST',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/reason.js